import TopNav from "../../home/components/TopNav";
import FSHeroV2 from "./v2/FSHeroV2";
import FSFeaturesV2 from "./v2/FSFeaturesV2";
import FSInsightsV2 from "./v2/FSInsightsV2";
import FSCasesV2 from "./v2/FSCasesV2";
import FSSystemDemoV2 from "./v2/FSSystemDemoV2";
import FSPricingV2 from "./v2/FSPricingV2";

export default function FinancialServicesPage() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Noto Sans SC', sans-serif" }}>
      <TopNav />
      <div className="pt-14">
        <FSHeroV2 />
        <FSFeaturesV2 />
        <FSInsightsV2 />
        <FSCasesV2 />
        <FSSystemDemoV2 />
        <FSPricingV2 />
      </div>
    </div>
  );
}
